module.exports = __webpack_public_path__ + "img/group_add_opsz24.6420d88e.svg";